import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Modal from "react-modal";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import Spinner from "../../components/Spinner";
import searchsmall from "../../assets/images/Search.svg";
import edit from "../../assets/images/edit.svg";
import editA from "../../assets/images/editAct.svg";
import trash from "../../assets/images/trash.svg";
import Alert from "../../assets/images/alert-circle.svg";
import closex from "../../assets/images/X.svg";
import copy from "../../assets/images/copy.svg";
import onboardingimage from "../../assets/images/status1.svg";

const OnboardingTemplates = () => {
  const navigate = useNavigate();
  const [onboardingTemplates, setOnboardingTemplates] = useState([]);
  const [loader, setLoader] = useState(true);
  const [searchKey, setSearchKey] = useState("");
  const [modalData, setModalData] = useState({});
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalDeleteIsOpen, setIsDeleteOpen] = useState(false);
  const [rename, setRename] = useState("");
  const [renameIndex, setRenameIndex] = useState(null);
  const [deleteIds, setDeleteIds] = useState([]);
  const [isCopyForm, setIsCopyForms] = useState(false);
  const [templateId, setTemplateId] = useState(0);
  const [company, setCompany] = useState([]);
  const [filterCompany, setFilterCompany] = useState(0);
  const [companyId, setCompanyId] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdminOnly, setIsAdminOnly] = useState(false);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };
  useEffect(() => {
    fetchOnboardingTemplates();
    let userData = JSON.parse(localStorage.getItem("UserAccess"));
    setCompany(userData?.Companies);
    if (
      userData?.Role === "super_admin" ||
      userData?.Role === "super_admin_viewer" ||
      userData?.Role === "org_user" ||
      userData?.Role === "org_owner"
    ) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    if (userData?.Role === "super_admin") {
      setIsAdminOnly(true);
    } else {
      setIsAdminOnly(false);
    }
  }, []);

  useEffect(() => {
    fetchOnboardingTemplates();
  }, [searchKey, filterCompany]);

  async function fetchOnboardingTemplates() {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      searchkey: searchKey,
    };
    if (filterCompany !== "0") {
      obj.companyId = filterCompany;
    }
    await ApiHelper.post(API.getSectionTemplates, obj)
      .then((resData) => {
        if (resData.status === 200) {
          console.log("resDataresData", resData);
          setOnboardingTemplates(resData.data.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }

  const deleteTemplate = async (id) => {
    setLoader(true);
    const formData = {
      templateid: id,
    };
    await ApiHelper.post(API.deleteSectionTemplate, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          setIsOpen(false);
          fetchOnboardingTemplates();
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const deleteMultipleTemplates = async () => {
    setLoader(true);
    const formData = {
      templateid: deleteIds,
    };
    await ApiHelper.post(API.deleteSectionTemplate, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          setDeleteIds([]);
          setIsDeleteOpen(false);
          fetchOnboardingTemplates();
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  function handleCheckboxChange(id) {
    let itemId = id.toString();
    if (deleteIds.includes(itemId)) {
      setDeleteIds((prev) => prev.filter((id) => id !== itemId));
    } else {
      setDeleteIds((prev) => [...prev, itemId]);
    }
  }

  const updateTempName = async (item) => {
    setLoader(true);
    const formData = {
      templateid: item?.id,
      template_name: rename,
    };
    await ApiHelper.post(API.updateTempName, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          fetchOnboardingTemplates();
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const copyTemplate = async (id) => {
    setLoader(true);
    const formData = {
      templateid: id,
    };
    await ApiHelper.post(API.copyTempSection, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          fetchOnboardingTemplates();
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const assignTemplate = async () => {
    if (templateId !== 0 && companyId !== 0) {
      setLoader(true);
      const formData = {
        template_id: templateId,
        company_id: companyId,
      };
      await ApiHelper.post(API.assignTemplate, formData)
        .then((resData) => {
          if (resData.data.success === true) {
            fetchOnboardingTemplates();
            setIsCopyForms(false);
          }
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-12 mt-2 ">
          <div className=" sidebar_open ">
            {isAdmin && (
              <div className="col-md-12 mb-3">
                <div class="row d-flex align-items-center">
                  <div class="team-member onbording-name-div col-md-8">
                    <li className="list-group-item same-line">
                      <div className="filterAlign">
                        <div className="row">
                          {company.length !== 0 && (
                            <div className="col-sm-3 col-lg-3">
                              <div className="main-filter">
                                {/*<p className="filter-name">Company :</p>*/}
                                <select
                                  class="form-select drop-filter customFilt"
                                  value={filterCompany}
                                  onChange={(e) => {
                                    console.log(e.target.value);
                                    setFilterCompany(e.target.value);
                                  }}
                                >
                                  <option selected value={0}>
                                    All Companies
                                  </option>
                                  {company?.map((item) => {
                                    return (
                                      <option value={item.id}>
                                        {" "}
                                        {item.company_name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </li>
                  </div>
                </div>

                <iframe
                  id="pdfViewer"
                  width="100%"
                  height="600px"
                  style={{ border: "1px solid #ccc", display: "none" }}
                />
              </div>
            )}
            <div className="tempops-border">
              <div className="modal-body  ">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="serchField mb-3 col-lg-5">
                    <img src={searchsmall} alt="test" className="serc_icon" />
                    <input
                      type="text"
                      className="sercInp"
                      placeholder="Search Process..."
                      onChange={(e) => {
                        setSearchKey(e.target.value);
                      }}
                    />
                  </div>
                  <div className="d-flex">
                    {deleteIds.length !== 0 ? (
                      <button
                        className="submits-btn rounded p-2 sub-bttn-right-sides temp-creat-bttn on-temp mx-2"
                        onClick={() => {
                          setIsDeleteOpen(true);
                        }}
                      >
                        Delete Process
                      </button>
                    ) : (
                      isAdmin &&
                      filterCompany !== "0" &&
                      filterCompany !== 0 && (
                        <button
                          className="submits-btn rounded p-2 sub-bttn-right-sides temp-creat-bttn on-temp mx-2"
                          onClick={() => {
                            setIsCopyForms(true);
                          }}
                        >
                          Copy Process
                        </button>
                      )
                    )}
                    <button
                      className="submits-btn rounded p-2 sub-bttn-right-sides e-vef-bttn-sub on-temp mx-2"
                      style={{ width: "110%" }}
                      onClick={() => {
                        navigate(
                          "/dashboard/onboarding/new-onboarding-template"
                        );
                      }}
                    >
                      Create Process
                    </button>
                  </div>
                </div>
                <div className=" wraper scrlHe-tab scroll scroll1 temppos-height ">
                  {onboardingTemplates.length === 0 ? (
                    <div className="col-lg-6 topnav-tab">
                      <a className="create-comp-popup-text-not-found">
                        <h6 className="create-comp-popup-text-heading-not-found temple-edits-cen">
                          {loader === false
                            ? "No templates found"
                            : "Loading..."}
                        </h6>
                      </a>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="table-responsive">
                        <table class="table">
                          <thead>
                            <tr>
                              <th style={{ width: "23%" }}>Process Name</th>
                              <th style={{ width: "23%" }}>Last Edited</th>
                              <th style={{ width: "23%" }}>Created On</th>
                              {isAdmin && <th>Company Name</th>}
                              <th className="last-handle-name">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {onboardingTemplates?.map((item, index) => {
                              return (
                                <tr className="temp-table-border">
                                  <td className="create-comp-popup-text">
                                    <input
                                      type="checkbox"
                                      className="mx-2"
                                      onChange={() =>
                                        handleCheckboxChange(item.id)
                                      }
                                      checked={deleteIds.includes(
                                        String(item.id)
                                      )}
                                    />
                                    {renameIndex === index ? (
                                      <div className="edit-in-width-divs">
                                        <input
                                          value={rename}
                                          className="input-temp-edts"
                                          onChange={(e) => {
                                            setRename(e.target.value);
                                          }}
                                          onBlur={() => {
                                            updateTempName(item);
                                            setRenameIndex(null);
                                          }}
                                        />
                                        <img
                                          src={edit}
                                          alt="trash"
                                          className="temp-edits-icon"
                                          onClick={() => {
                                            updateTempName(item);
                                            setRenameIndex(null);
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <h6 className="create-comp-popup-text-heading pops-text-width">
                                        {item?.template_name !== null
                                          ? item?.template_name
                                          : item?.title}
                                        <img
                                          src={edit}
                                          alt="trash"
                                          className="temp-edits-icon"
                                          onClick={() => {
                                            setRename(
                                              item?.template_name !== null
                                                ? item?.template_name
                                                : item?.title
                                            );
                                            setRenameIndex(index);
                                          }}
                                        />
                                      </h6>
                                    )}
                                  </td>
                                  <td>
                                    <span className="trash-edit create-comp-popup-text-heading">
                                      {moment(item?.updated_at).format(
                                        "MMM DD, YYYY, hh:mm a"
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="trash-edit create-comp-popup-text-heading">
                                      {moment(item?.created_at).format(
                                        "MMM DD, YYYY, hh:mm a"
                                      )}
                                    </span>
                                  </td>
                                  {isAdmin && (
                                    <td>
                                      <span className="trash-edit create-comp-popup-text-heading">
                                        {item.createdBy}
                                      </span>
                                    </td>
                                  )}
                                  <td>
                                    <div className="icons-ed">
                                      <span class="icon-trash ">
                                        <img
                                          src={edit}
                                          alt="trash"
                                          className="trash-icon-popups"
                                          onClick={() => {
                                            navigate(
                                              "/dashboard/onboarding/edit-onboarding-template"
                                            );
                                            localStorage.setItem(
                                              "Tempdata",
                                              JSON?.stringify(item)
                                            );
                                          }}
                                        />
                                      </span>
                                      <span class="icon-trash ">
                                        <img
                                          src={copy}
                                          alt="trash"
                                          className="trash-icon-popups"
                                          onClick={() => {
                                            copyTemplate(item?.id);
                                          }}
                                        />
                                      </span>
                                      <span class="icon-trash ">
                                        <img
                                          src={trash}
                                          alt="trash"
                                          className="trash-icon-popups"
                                          onClick={() => {
                                            setModalData(item);
                                            setIsOpen(true);
                                          }}
                                        />
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* onboardingTemplates?.map((item, index) => {
                      return (

                        
                        <div className="col-lg-12 topnav-tab box-left">
                          <a className="create-comp-popup-text">
                            {renameIndex === index ? (
                              <div className="edit-in-width-divs">
                                <input
                                  value={rename}
                                  onChange={(e) => {
                                    setRename(e.target.value);
                                  }}
                                  onBlur={() => {
                                    updateTempName(item);
                                    setRenameIndex(null);
                                  }}
                                />
                                <img
                                  src={edit}
                                  alt="trash"
                                  className="temp-edits-icon"
                                  onClick={() => {
                                    updateTempName(item);
                                    setRenameIndex(null);
                                  }}
                                />
                              </div>
                            ) : (
                              <h6 className="create-comp-popup-text-heading pops-text-width">
                                {item?.template_name !== null
                                  ? item?.template_name
                                  : item?.title}
                                <img
                                  src={edit}
                                  alt="trash"
                                  className="temp-edits-icon"
                                  onClick={() => {
                                    setRename(
                                      item?.template_name !== null
                                        ? item?.template_name
                                        : item?.title
                                    );
                                    setRenameIndex(index);
                                  }}
                                />
                              </h6>
                            )}
                            <span className="trash-edit create-comp-popup-text-heading">
                              Edited on{" "}
                              {moment(item?.updated_at).format("MMM DD, YYYY")}
                            </span>
                            <div className="icons-ed">
                              <span class="icon-trash mx-5">
                                <img
                                  src={edit}
                                  alt="trash"
                                  className="trash-icon-popups"
                                  onClick={() => {
                                    navigate(
                                      "/dashboard/onboarding/edit-onboarding-template"
                                    );
                                    localStorage.setItem(
                                      "Tempdata",
                                      JSON?.stringify(item)
                                    );
                                  }}
                                />
                              </span>
                              <span class="icon-trash mx-5">
                                <img
                                  src={copy}
                                  alt="trash"
                                  className="trash-icon-popups"
                                  onClick={() => {
                                    copyTemplate(item?.id);
                                  }}
                                />
                              </span>
                              <span class="icon-trash mx-5">
                                <img
                                  src={trash}
                                  alt="trash"
                                  className="trash-icon-popups"
                                  onClick={() => {
                                    setModalData(item);
                                    setIsOpen(true);
                                  }}
                                />
                              </span>
                            </div>
                          </a>
                        </div>
                      );
                    })
                  )} */}
                </div>
              </div>

              {loader && <Spinner />}
            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          style={customStyles}
          contentLabel="Example Modal"
          className="delet-temp"
        >
          <div className="modal-width dltPops">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Delete Process
            </h2>

            <button onClick={() => setIsOpen(false)} className="modal-close">
              <img src={closex} alt="copy" className="create-icon m-0" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts pb-0">
              Are you sure you want to delete{" "}
              {modalData?.template_name !== null
                ? modalData?.template_name
                : modalData?.title}{" "}
              process?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button
                className="yes-btn rounded p-2"
                onClick={() => {
                  deleteTemplate(modalData?.id);
                }}
              >
                {" "}
                Yes{" "}
              </button>
              <p className="cancel-bttn" onClick={() => setIsOpen(false)}>
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>

      <div>
        <Modal
          isOpen={modalDeleteIsOpen}
          onRequestClose={() => setIsDeleteOpen(false)}
          style={customStyles}
          contentLabel="Example Modal"
          className="delet-temp"
        >
          <div className="modal-width dltPops">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Delete Process
            </h2>

            <button
              onClick={() => setIsDeleteOpen(false)}
              className="modal-close"
            >
              <img src={closex} alt="copy" className="create-icon m-0" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts pb-0">
              Are you sure you want to delete these processes?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button
                className="yes-btn rounded p-2"
                onClick={() => {
                  deleteMultipleTemplates();
                }}
              >
                {" "}
                Yes{" "}
              </button>
              <p className="cancel-bttn" onClick={() => setIsDeleteOpen(false)}>
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>
      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={isCopyForm}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width mt-2">
            <h2 className="text-right text-xl modal-text">
              <img
                src={onboardingimage}
                alt="copy"
                className="create-icon mb-0 me-2"
              />
              Copy Process
              <button
                onClick={() => {
                  setIsCopyForms(false);
                }}
                className="close-bttn "
              >
                <img
                  src={closex}
                  alt="close"
                  className="create-icon mb-0 me-2 modal-close"
                />
              </button>
            </h2>
            <hr />
            <div className="Copy-Process-mod-inner">
              <div class="col-lg-12 px-1 mb-2">
                <div class="form-group mt-0 mb-2 alertField">
                  <label class="form-label job-text mb-1">Template name:</label>
                  <div class="select">
                    <select
                      class="form-select "
                      style={{
                        border: templateId === 0 ? "1px solid red" : null,
                      }}
                      onChange={(e) => {
                        setTemplateId(e.target.value);
                      }}
                    >
                      <option value="0">Select</option>
                      {onboardingTemplates.map((item) => {
                        return (
                          <option value={item?.id}>
                            {item?.template_name}
                          </option>
                        );
                      })}
                    </select>
                    <i className="mt-3">
                      <small>Fill in the new template name.</small>
                    </i>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 px-1 mb-4">
                <div class="form-group mt-0 mb-2 alertField">
                  <label class="form-label job-text mb-1">
                    Select Company:
                  </label>
                  <div class="select">
                    <select
                      class="form-select "
                      style={{
                        border: companyId === 0 ? "1px solid red" : null,
                      }}
                      onChange={(e) => {
                        setCompanyId(e.target.value);
                      }}
                    >
                      <option value="0">Select</option>
                      {company?.map((item) => {
                        return (
                          <option value={item?.id}>{item?.company_name}</option>
                        );
                      })}
                    </select>
                    <i className="mt-3">
                      <small>
                        Select the company you want to duplicate this template
                        to.
                      </small>
                    </i>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 text-end mb-3">
                <button
                  type="button"
                  class="btn btn-primary Add-pop mx-3"
                  onClick={assignTemplate}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default OnboardingTemplates;
